var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6609 29.3229H23.9916C24.6986 29.3229 25.3766 29.0421 25.8765 28.5421C26.3764 28.0422 26.6573 27.3642 26.6573 26.6572V9.33001L19.993 2.66571H7.99726C7.29027 2.66571 6.61223 2.94656 6.11231 3.44648C5.61239 3.9464 5.33154 4.62444 5.33154 5.33143V17.9936",
    stroke: "#4A5565",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 2.66571V7.99715C18.6602 8.70414 18.941 9.38218 19.4409 9.8821C19.9408 10.382 20.6189 10.6629 21.3259 10.6629H26.6573",
    stroke: "#4A5565",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.831 20.8273C18.0939 20.5644 18.3024 20.2522 18.4447 19.9088C18.587 19.5653 18.6602 19.1971 18.6602 18.8253C18.6602 18.4535 18.587 18.0853 18.4447 17.7419C18.3024 17.3984 18.0939 17.0862 17.831 16.8233C17.5681 16.5604 17.256 16.3519 16.9125 16.2096C16.569 16.0673 16.2008 15.9941 15.829 15.9941C15.4572 15.9941 15.0891 16.0673 14.7456 16.2096C14.4021 16.3519 14.09 16.5604 13.8271 16.8233L7.14945 23.5036C6.83256 23.8204 6.60061 24.2118 6.47502 24.6419L5.35942 28.4672C5.32597 28.5819 5.32396 28.7035 5.35361 28.8192C5.38326 28.9349 5.44348 29.0406 5.52796 29.125C5.61243 29.2095 5.71807 29.2697 5.8338 29.2994C5.94953 29.329 6.0711 29.327 6.18579 29.2936L10.0111 28.178C10.4412 28.0524 10.8326 27.8204 11.1494 27.5036L17.831 20.8273Z",
    stroke: "#4A5565",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.29bd78a9227bd94eca9ff15b7ed5bbd4.svg";
export { ForwardRef as ReactComponent };